import React, { useEffect, useState } from "react";
import Modal from "@/components/Modal";
import { useTranslation } from "@/langs/useTranslation";
import MemoedHOC from "@/hoc/MemoedHOC";
import SingleSelector from '@/components/SingleSelector';
import { toast } from "@/helpers/toast"

function TranserModal({ open, value, onSelect, onConfirm, onClose }) {
  const { t } = useTranslation();
  const [selected, setSelected] = useState([]);

  const handleConfirm = () => {
    if (!selected.length) {
      toast.info(t({ defaultMessage: "请选择一个版本" }));
      return;
    }
    return onConfirm?.(
      selected
    );
  };

  const handleChange = e => {
    const { value } = e.target;
    setSelected(value);
    onSelect?.(
      value
    );
  };

  useEffect(() => {
    if (!open) {
      setSelected([]);
    }
  }, [open]);

  useEffect(() => {
    if (value) {
      setSelected(value);
    }
  }, [value]);

  return (
    <Modal
      title={t({ defaultMessage: "修改版本" })}
      open={open}
      onClose={onClose}
      onConfirm={handleConfirm}
      className="StoreUpdateStatusModal"
    >
      <div class="subTitle">{t({defaultMessage: "是否将选择的设备版本改为"})}</div>
      <SingleSelector
        placeholder={t({ defaultMessage: "选择设备版本" })}
        options={[
          { name: "Pro", id: "nubis_pro" },
          { name: "Free", id: "nubis_free" }
        ]}
        clearable
        name="StoreUpdateVersion"
        initialValue=""
        value={selected}
        onChange={handleChange}
      />
    </Modal>
  );
}

export default MemoedHOC(TranserModal);
